import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M5.2837 2.55344L3.05132 5.00258C2.99605 5.07063 2.98542 5.14502 3.01944 5.22582C3.05351 5.30653 3.11512 5.34706 3.20446 5.34706L4.63317 5.34706L4.63317 12.3069C4.63317 12.3664 4.65227 12.4154 4.69054 12.4536C4.72878 12.4918 4.77771 12.511 4.83722 12.511L6.06179 12.511C6.12128 12.511 6.1702 12.4919 6.2084 12.4536C6.24665 12.4153 6.26575 12.3664 6.26575 12.3069L6.26575 5.34701L7.69444 5.34701C7.77959 5.34701 7.84121 5.30642 7.87936 5.22575C7.91352 5.14488 7.90061 5.07049 7.84121 5.00245L5.58318 2.55331C5.54069 2.51079 5.48976 2.48959 5.43018 2.48959C5.37504 2.48959 5.32621 2.51093 5.2837 2.55344Z",
      fill: "#00B242"
    }, null, -1),
    _createElementVNode("path", {
      d: "M10.3857 13.447L8.15337 10.9979C8.0981 10.9299 8.08747 10.8555 8.12149 10.7747C8.15556 10.694 8.21717 10.6534 8.30651 10.6534L9.73522 10.6534L9.73522 3.6936C9.73522 3.63404 9.75432 3.58512 9.79259 3.54689C9.83083 3.50869 9.87976 3.4895 9.93927 3.4895L11.1638 3.4895C11.2233 3.4895 11.2723 3.5086 11.3105 3.54687C11.3487 3.58518 11.3678 3.63411 11.3678 3.69357L11.3678 10.6535L12.7965 10.6535C12.8816 10.6535 12.9433 10.6941 12.9814 10.7747C13.0156 10.8556 13.0027 10.93 12.9433 10.998L10.6852 13.4472C10.6427 13.4897 10.5918 13.5109 10.5322 13.5109C10.4771 13.5109 10.4283 13.4896 10.3857 13.447Z",
      fill: "#E11D23"
    }, null, -1)
  ])))
}